import { cn } from "@/lib/utils";
import type { IconProps } from "./icon-base";

interface LogoProps extends IconProps {
  animated?: boolean;
}

export default function Logo({ className, animated, ...props }: LogoProps) {
  return (
    <svg
      aria-hidden="true"
      className={cn("overflow-visible", animated && "group/logo", className)}
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="logo-grad"
          x1="0"
          x2="0"
          y1="0"
          y2="32"
        >
          <stop offset="0%" stopColor="var(--color-gray-500)" />
          <stop offset="50%" stopColor="var(--color-gray-1000)" />
          <stop offset="100%" stopColor="var(--color-gray-600)" />
        </linearGradient>
      </defs>
      <path
        className="transition-transform duration-300 ease-out group-hover/logo:translate-y-1"
        d="M4 12.002C4 10.9797 4.67166 10.0789 5.65144 9.78706L13.9764 7.30769C15.4583 6.86635 16.9472 7.97645 16.9472 9.52265V25.4675C16.9472 26.4898 16.2755 27.3907 15.2958 27.6825L6.97077 30.1619C5.4889 30.6032 4 29.4931 4 27.9469V12.002Z"
        fill="var(--color-gray-500)"
      />
      <path
        className="transition-transform duration-300 ease-out group-hover/logo:-translate-y-0.5"
        d="M9.57353 6.53417C9.57353 5.51185 10.2452 4.61101 11.225 4.3192L19.55 1.83983C21.0318 1.3985 22.5207 2.5086 22.5207 4.05479V19.9997C22.5207 21.022 21.8491 21.9228 20.8693 22.2146L12.5443 24.694C11.0624 25.1353 9.57353 24.0252 9.57353 22.479V6.53417Z"
        fill="url(#logo-grad)"
      />
      <path
        className="transition-transform duration-300 ease-out group-hover/logo:translate-y-0.75"
        d="M15.0528 12.002C15.0528 10.9797 15.7245 10.0789 16.7042 9.78706L25.0292 7.30769C26.5111 6.86636 28 7.97646 28 9.52265V25.4675C28 26.4898 27.3283 27.3907 26.3486 27.6825L18.0236 30.1619C16.5417 30.6032 15.0528 29.4931 15.0528 27.9469V12.002Z"
        fill="var(--color-gray-700)"
      />
    </svg>
  );
}
